import { render, staticRenderFns } from "./Pagado.vue?vue&type=template&id=82d4a1f2"
import script from "./Pagado.vue?vue&type=script&lang=js"
export * from "./Pagado.vue?vue&type=script&lang=js"
import style0 from "./Pagado.vue?vue&type=style&index=0&id=82d4a1f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports